export const ActionError = {
  MessageOnly: "MESSAGE_ONLY",
  GoBack: "GO_BACK",
  Retry: "RETRY",
  Reset: "RESET",
  Logout: "LOGOUT",
} as const;